<!-- <h2 mat-dialog-title>Logout Session</h2>

<mat-dialog-content>

<p> We haven't received anything from your side since a long time, Do you want to continue?  </p>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" (click)="close('Y')">Yes</button>
    <button class="mat-raised-button" (click)="close('N')">No</button>
</mat-dialog-actions> -->



<div class="confirm">
    <h1 matDialogTitle>Logout Session</h1>
    <p>Do you want to continue with the current user?</p>
    <div mat-dialog-actions class="pt-24 action">
    <button class="cancel" (click)="ClickNo('N')">No</button>
    <button  class="confirm" (click)="ClickYes('Y')">Yes</button>
</div>

</div>